import React, { useEffect, useState } from 'react';
import AddButton from '../../components/common/AddButton/AddButton';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import Filter from '../../components/common/Filter/Filter';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import Sort from '../../components/common/Sort/Sort';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import './Languages.css';
import { baseurl } from '../../api';
import { isTextOnly,isRequired } from '../../validation';
import authenticatedAxios from '../../authenticatedAxios';
import { useCheckboxClick } from '../../checkboxclick';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "languages"

const Languages = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [items, setItems] = useState([]); 
  const [popupError, setPopupError] = useState('');
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [selectedGroupArchiveAction, setSelectedGroupArchiveAction] = useState('');
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Languages"] || 0;

  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];


  const fetchLanguages = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}localization/languages/?id=${id}`);
        if (response && response.data) {
          setSelectedLanguage(response.data.data);
          setIsEditPopupOpen(true);
        } else {
          console.error("No data found for the selected language.");
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
  
        const response = await authenticatedAxios.get(`${baseurl}localization/languages/`, { params });
        setItems(response.data?.data || []);
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching languages:', error);
      }
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}localization/languages/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchLanguages();
        resetCheckboxState();
        setIsArchivePopupOpen(false);
      } 
    } catch (error) {
      
    }
  };
  
  useEffect(() => {
    
    fetchLanguages();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]); 

  useEffect(() => {
    fetchLanguages();
  }, [refreshKey]);

  const handleSearchSelect = (term) => {
    setSearchParams({term });
  };

  const handleAddLanguage = async (formValues) => {
    try {
      const response = await authenticatedAxios.post(
        `${baseurl}localization/languages/`,
        formValues
      );
  
      if (response.data.response_code === 1) {
        await fetchLanguages();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to add language. Please try again.');
    }
  };
  
  const handleEditLanguage = async (formValues) => {
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}localization/languages/?id=${selectedLanguage.id}`,
        formValues
      );
  
      if (response.data.response_code === 1) {
        await fetchLanguages();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to update language. Please try again.');
    }
  };
  

  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}localization/languages/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchLanguages(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error deleting plan:', error);
    }
  };

  const handleArchive= async () => {
    try {
        const response = await authenticatedAxios.get(`${baseurl}localization/languages/archive/?id=${selectedItem.id}`);

        if (response.status >= 200 && response.status < 300) {
            await fetchLanguages();
            closePopups();
        } else {
            console.error('Failed to archive tax.');
        }
    } catch (error) {
        console.error('Error archiving tax:', error);
    }
  };

  const handleEditClick = (language) => {
    fetchLanguages(language.id);
    
  };

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const handleNewClick = () => {
    setSelectedLanguage(null);
    setIsNewPopupOpen(true);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setSelectedLanguage(null);
    setSelectedItem([])
    setPopupError('');
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const editPopupFields = [
    { label: 'Language Name', 'name':'name',type: 'large-input', validators: [isRequired, isTextOnly], defaultValue: selectedLanguage?.name || '' },
    { label: 'ISO 3166 Code', 'name':'iso_code', type: 'large-input',validators: [isRequired], defaultValue: selectedLanguage?.iso_code || '' },
    { label: 'Direction', 'name':'direction',type: 'large-select', options: [{ label: 'RTL', value: 'RTL' }, { label: 'LTR', value: 'LTR' }], defaultValue: selectedLanguage?.direction || '' }
  ];

  const addPopupFields = [
    { label: 'Language Name','name':'name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
    { label: 'ISO 3166 Code','name':'iso_code', type: 'large-input', defaultValue: '', validators: [isRequired] },
    { label: 'Direction', 'name':'direction',type: 'large-select', options: [{ label: 'RTL', value: 'RTL' }, { label: 'LTR', value: 'LTR' }], defaultValue: '', validators: [isRequired] }
  ];



  const handleExportComplete = () => {
    resetCheckboxState();
  };


  return (
    <div className="whole-container">
      <div className="top-heading">
        <PageHeader pageName="Languages" />
        <div className="export-container">
          {/* <DownloadLabel /> */}
          <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          <ExportLabel
            exportUrl={`${baseurl}localization/languages/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />
        </div>
      </div>
      <div className="pagename-container">
        <div className="page-name">
          <h1 className="common-text fts-22 ftw-6 blue">Languages</h1>
        </div>
        <div className="pagename-right-container">
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search language" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className="table-container">
        <table className="common-table">
          <thead className="common-table-head">
            <tr className="common-table-thead-tr">
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />LANGUAGE NAME
              </th>
              <th>ISO 3166 CODE</th>
              <th>DIRECTION</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="common-table-tbody">
          {items.length > 0 ? (
            items.map((language) => (
              <tr
                key={language.id}
                className={language.is_archived ? 'archived-item' : ''}
              >
                <td className='d-flex ai-center'>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(language.id)}
                    onChange={() => handleChildCheckboxChange(language.id)}
                  />{language.name}
                </td>
                <td>{language.iso_code}</td>
                <td>{language.direction}</td>
                <td className="actions">
                  <EditIcon onClick={() => handleEditClick(language)} />
                  <ArchiveIcon
                    onClick={() => handleArchiveClick(language)}
                    isArchived={language.is_archived}
                  />
                  <DeleteIcon onClick={() => handleDeleteClick(language)} /> 
                </td>
                </tr>
              ))


          ):(
            <tr>
              <td colSpan="3">No Languages Available</td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

      <EditPopup
        isOpen={isEditPopupOpen}
        title="Edit Language"
        fields={editPopupFields}
        onSave={handleEditLanguage}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />

      <AddPopup
        isOpen={isNewPopupOpen}
        title="New Language"
        buttonName='Add Language'
        fields={addPopupFields}
        onSave={handleAddLanguage}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />


      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />

      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete Recipient Group"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />
      
    </div>
  );
};

export default Languages;